// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { FactoryObject_abstract } from './../abstract/SagaBase/FactoryObject_abstract';
export class FactoryObject extends FactoryObject_abstract {}
